import {MutationTree} from "vuex";
import IProject from "@/modules/ProjectManager/ts/IProject";
import Question from "@/modules/RegistrationSurvey/ts/Question";
import IQuestionVariable from "@/modules/RegistrationSurvey/ts/IQuestionVariable";
import moment from 'moment';

export const mutations: MutationTree<any> = {

    setOAuthData(state: any, payload: any) {
        state.oauth = payload;
        state.authenticated = true;
    },

    setConfig(state: any, payload: any) {
        state.config = payload;
    },

    setBuild(state: any, payload: Number) {
        state.build = payload;
    },

    setAccountDetails(state: any, payload: any) {
        state.account = payload;
        state.accountExpires = moment().add(1, 'hour');
    },

    setAvailableProjects(state: any, payload: any) {
        state.availableProjects = payload;
        state.availableProjectsExpires = moment().add(15, 'minute');
    },

    setAvailableQuestions(state: any, payload: any) {
        state.availableQuestions = payload.questions;
        state.locale = payload.locale;
        state.availableQuestionsExpires = moment().add(1, 'hour');

        state.questions = [];
        state.availableQuestions.forEach((serverQuestion: IQuestionVariable) => {
            state.questions.push(new Question(serverQuestion))
        });
    },

    setRewards(state: any, payload: any) {
        state.rewards = payload;
        state.rewardsExpires = moment().add(1, 'hour');
    },

    setCollectedData(state: any, payload: any) {
        state.collectedData = payload;
    },

    setRedemptionHistory(state: any, payload: any) {
        state.redemptionHistory = payload;
        state.redemptionHistoryExpires = moment().add(1, 'hour');
    },

    setActivityHistory(state: any, payload: any) {
        state.activityHistory = payload;
        state.activityHistoryExpires = moment().add(1, 'hour');
    },

    deleteProject(state: any, payload: number) {
        let index = state.availableProjects.findIndex((p: IProject) => p.id === payload);
        state.availableProjects.splice(index, 1);
    },

    addRewardPoints(state: any, payload: Number) {
        state.account.points_balance += payload;
    },

    deductRewardPoints(state: any, reward: any) {
        state.account.points_balance -= parseInt(reward.reward_point_cost);
    },

    clearRedemptionHistoryCache(state: any) {
        state.redemptionHistoryExpires = null;
    },

    clearAvailableProjectsCache(state: any) {
        state.availableProjectsExpires = null;
    }
};
